import React from "react";
import { useFetchOicplCsrDataQuery } from "../store/rtk/oicplCommittee";
import Banner from "./Banner";
import { Link } from "react-router-dom";
import { Loader } from "../shared/Loader";
import { Helmet } from "react-helmet";
const OicplCsr = () => {
    const {isFetching, data } = useFetchOicplCsrDataQuery();
   
    return (
        <>
          <Helmet>
        <title>Nucleus office park | Investors</title>
        <meta
          name="description"
          content="this is about page of nuclous park"
        />
      </Helmet>
            {/* banner */}
            {isFetching && <Loader/>}
            <section className="banner_image_common">
                     <Banner urlName={"investor-sub-pages"} />
            </section>
            {/* banner */}

            {/* OicplCsr */}
            <section className="investore">
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-light nav_section">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link active" id="nav-one-link" to="/investors" role="tab" aria-controls="nav-one" aria-selected="true">
                                    One International Center Private Limited
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" id="nav-office-link" to="/noppl-csr" role="tab" aria-controls="nav-office" aria-selected="false">
                                    Nucleus Office Parks Private Limited
                                </Link>
                            </li>
                        </ul>
                    </nav>
                    <div className="row investore_heading justify-content-between  "><div className="col-md-2"><h1 className="mt-3 mb-lg-0 mb-4">
                        <Link to="/investors"><i className="bi bi-arrow-left"></i> Back</Link></h1></div><div className="col-md-8 text-center"><h1 className="pt-0 ">{data?.data?.attributes?.Title}</h1></div><div className="col-md-2"></div></div>
                    
                </div>
            </section>
            {/* OicplCsr */}
        </>
    );
};
export default OicplCsr;
